import axios from "axios";

const baseUrl = process.env.REACT_APP_API_SERVICE;

export const getUserMembers = async () => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.get(`${baseUrl}user/member/all?access_token=${token}`);
};

export const getPermissions = async (userId) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	if (userId)
		return axios.get(
			`${baseUrl}user/permissions/${userId}?access_token=${token}`
		);
	return axios.get(`${baseUrl}user/permissions/?access_token=${token}`);
};

export const addUser = async (data) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.post(`${baseUrl}user/member?access_token=${token}`, data);
};

export const editUser = async (userId, data) => {
	const user = localStorage.getItem("user");
	const token = JSON.parse(user).access_token;
	return axios.patch(
		`${baseUrl}user/member/${userId}?access_token=${token}`,
		data
	);
};

export default {
	getUserMembers,
	getPermissions,
	addUser,
	editUser,
};
